import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "pageTitle": "Design Guidelines - Getting Started",
  "title": "Getting Started",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <PageContent componentName="getting_started" type="design_intro" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  If you're new to designing with React Magma, then this is the right place to
  start. You'll find below everything you need to get going.
      </LeadParagraph>
      <hr></hr>
      <h2>{`Designing with React Magma`}</h2>
      <p>{`The React Magma team strives to provide detailed usage and style documentation. It's important to become familiar with this guidance when you are designing with our components. Consider starting with the foundations of `}<a parentName="p" {...{
          "href": "/version/4.9.1/design-intro/colors/"
        }}>{`color`}</a>{`, `}<a parentName="p" {...{
          "href": "/version/4.9.1/design-intro/typography/"
        }}>{`typography`}</a>{`, `}<a parentName="p" {...{
          "href": "/version/4.9.1/design-intro/spacing/"
        }}>{`spacing`}</a>{`, and `}<a parentName="p" {...{
          "href": "/version/4.9.1/design/icon/"
        }}>{`icons`}</a>{`, and then continue with the components.`}</p>
      <p>{`We also welcome contributions from people outside the React Magma team. This includes both designers within Cengage as well as outside. Join us over on our `}<a parentName="p" {...{
          "href": "https://github.com/cengage/react-magma"
        }}>{`Github`}</a>{` page to start contributing today.`}</p>
      <hr></hr>
      <h2>{`Resources & Tools`}</h2>
      <p>{`At Cengage we use Figma for our primary design tool and we have component libraries available for you to use. To access these libraries you'll need to sign in to the Cengage Figma organization using your Cengage email address.`}</p>
      <p>{`In your design file, you'll have four libraries available for you to turn on:`}</p>
      <ol>
        <li parentName="ol">{`React Magma 3 Foundations`}</li>
        <li parentName="ol">{`React Magma 3 Components`}</li>
        <li parentName="ol">{`Cengage logos`}</li>
        <li parentName="ol">{`Material Design Icons`}</li>
      </ol>
      <p>{`If you have any questions or issues, please reach out in the #react-magma Slack channel.`}</p>
      <hr></hr>
      <h2>{`Guiding Principles`}</h2>
      <p>{`Cengage exists to empower students and instructors with the audacity to realize their potential and the tenacity to achieve their goals.
React Magma helps us build tools that are relevant and easy to use, and create educational experiences that accelerate learning while putting our users at the center of everything we do. The following design principles guide every decision we make.`}</p>
      <div className="principles-c">
  <h3>Anticipate Needs</h3>
  <p>
    Don't overburden me with options or choice. Proactively assume what I need
    and when, while equipping me with the ability to change it.
  </p>
  <blockquote>
    <p>
      &ldquo;I hate going through each student or each activity and changing
      things when I'm changing the same thing ... on 10, 20 or 30 of them. It is
      so time consuming.&rdquo;
    </p>
    <footer>&ndash; MindTap Instructor</footer>
  </blockquote>
      </div>
      <div className="principles-c">
  <h3>Tolerate Mistakes</h3>
  <p>
    Mistakes are proof that I’m trying, but they should never impede my
    education experience. Preventing and helping me recover from a mistake
    should be as easy as it was to make it.
  </p>
  <blockquote>
    <p>
      &ldquo;...I feel like I am not learning with this software because I have
      no way of knowing where I made my mistakes.&rdquo;
    </p>
    <footer>&ndash; SAM Student</footer>
  </blockquote>
      </div>
      <div className="principles-c">
  <h3>Inspire Confidence</h3>
  <p>
    Build confidence at every opportunity. Confidence that I can improve my
    understanding, confidence that the paragraph I just wrote won’t get lost and
    confidence that I won’t get lost.
  </p>
  <blockquote>
    <p>
      &ldquo;I’m calling in because all of my material on my account is
      gone.&rdquo;
    </p>
    <footer>&ndash; MindTap Instructor</footer>
  </blockquote>
      </div>
      <div className="principles-c">
  <h3>Cultivate Focus</h3>
  <p>
    Distractions are plentiful and my undivided attention is scarce. Any
    interference must be purposefully crafted to never override my education
    experience.
  </p>
  <blockquote>
    <p>
      &ldquo;... You also put up an online pop-up advertisement that would not
      go away for a solid week and prevented me from being able to complete the
      homework for that week at a reasonable pace.&rdquo;
    </p>
    <footer>&ndash; WebAssign Student</footer>
  </blockquote>
      </div>
      <div className="principles-c">
  <h3>Preserve Simplicity</h3>
  <p>
    Be intentionally simple. Making common tasks fast, and easy for me to
    understand without explanation allows me to concentrate on my education
    experience.
  </p>
  <blockquote>
    <p>
      &ldquo;The organization was complicated and it was difficult to find
      assignments that were due...&rdquo;
    </p>
    <footer>&ndash; MindTap Student</footer>
  </blockquote>
      </div>
      <div className="principles-c">
  <h3>Encourage Mobility</h3>
  <p>
    I am not constrained by device or location and I expect the same of my
    education experience. Mobile empowers me to succeed, regardless of location,
    device or time.
  </p>
  <blockquote>
    <p>
      &ldquo;I shouldn't have to use my computer to take my tests or do my
      homework when I have a perfectly capable mobile device. I take online
      courses so that I can do my homework anywhere anytime.&rdquo;
    </p>
    <footer>&ndash; CNOW Student</footer>
  </blockquote>
      </div>
      <span className="horizontal-spacer" />
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      